import { render, staticRenderFns } from "./SelectionManagementEmpty.vue?vue&type=template&id=0c0d64e2&"
import script from "./SelectionManagementEmpty.vue?vue&type=script&lang=js&"
export * from "./SelectionManagementEmpty.vue?vue&type=script&lang=js&"
import style0 from "./SelectionManagementEmpty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
